"use strict";
/**
 * This code was generated by generateTsPackage.
 * Do not edit it manually
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTokenCreator = exports.getSplitShareLength = exports.getSellerOrOwnersOf = exports.getSellerOrOwnersFromCollection = exports.getSellerOrOwnerOf = exports.getPercentSplitETH = exports.getNFTDetails = exports.getNFTDetailString = exports.getFeesV3 = exports.getFees = exports.getDutchAuctionV3 = exports.getDutchAuction = exports.getAccountInfoV2 = void 0;
exports.getAccountInfoV2 = {
    parseOutput: (output) => {
        return {
            /** ethBalance (uint256) */
            ethBalance: output[0],
            /** availableFethBalance (uint256) */
            availableFethBalance: output[1],
            /** lockedFethBalance (uint256) */
            lockedFethBalance: output[2],
        };
    },
};
exports.getDutchAuction = {
    parseOutput: (output) => {
        return {
            /** currentPrice (uint256) */
            currentPrice: output[0],
            /** nextPrice (uint256) */
            nextPrice: output[1],
            /** blockNumber (uint256) */
            blockNumber: output[2],
            /** blockTime (uint256) */
            blockTime: output[3],
            /** totalMinted (uint256) */
            totalMinted: output[4],
            /** totalAvailableSupply (uint256) */
            totalAvailableSupply: output[5],
            /** outstandingRebateBalance (uint256) */
            outstandingRebateBalance: output[6],
            /** totalFundsPendingDistribution (uint256) */
            totalFundsPendingDistribution: output[7],
        };
    },
};
exports.getDutchAuctionV3 = {
    parseOutput: (output) => {
        return {
            /** currentPrice (uint256) */
            currentPrice: output[0],
            /** mintedNftCount (uint256) */
            mintedNftCount: output[1],
            /** totalNftCount (uint256) */
            totalNftCount: output[2],
            /** outstandingRebateBalance (uint256) */
            outstandingRebateBalance: output[3],
            /** totalFundsPendingDistribution (uint256) */
            totalFundsPendingDistribution: output[4],
            /** mintFeePerNftInWei (uint256) */
            mintFeePerNftInWei: output[5],
        };
    },
};
exports.getFees = {
    parseOutput: (output) => {
        return {
            /** protocol (struct FNDMiddleware.FeeWithRecipient) */
            protocol: output[0],
            /** creator (struct FNDMiddleware.Fee) */
            creator: output[1],
            /** owner (struct FNDMiddleware.FeeWithRecipient) */
            owner: output[2],
            /** creatorRevSplit (struct FNDMiddleware.RevSplit[]) */
            creatorRevSplit: output[3],
        };
    },
};
exports.getFeesV3 = {
    parseOutput: (output) => {
        return {
            /** protocol (struct FNDMiddleware.FeeWithRecipient) */
            protocol: output[0],
            /** creator (struct FNDMiddleware.Fee) */
            creator: output[1],
            /** owner (struct FNDMiddleware.FeeWithRecipient) */
            owner: output[2],
            /** creatorRevSplit (struct FNDMiddleware.RevSplit[]) */
            creatorRevSplit: output[3],
            /** world (struct FNDMiddleware.FeeWithRecipient) */
            world: output[4],
            /** buyReferrerFee (struct FNDMiddleware.FeeWithRecipient) */
            buyReferrerFee: output[5],
        };
    },
};
exports.getNFTDetailString = {
    parseOutput: (output) => {
        return {
            /** details (string) */
            details: output[0],
        };
    },
};
exports.getNFTDetails = {
    parseOutput: (output) => {
        return {
            /** owner (address) */
            owner: output[0],
            /** isInEscrow (bool) */
            isInEscrow: output[1],
            /** auctionBidder (address) */
            auctionBidder: output[2],
            /** auctionEndTime (uint256) */
            auctionEndTime: output[3],
            /** auctionPrice (uint256) */
            auctionPrice: output[4],
            /** auctionId (uint256) */
            auctionId: output[5],
            /** buyPrice (uint256) */
            buyPrice: output[6],
            /** offerAmount (uint256) */
            offerAmount: output[7],
            /** offerBuyer (address) */
            offerBuyer: output[8],
            /** offerExpiration (uint256) */
            offerExpiration: output[9],
        };
    },
};
exports.getPercentSplitETH = {
    parseOutput: (output) => {
        return {
            /** splitAddress (address) */
            splitAddress: output[0],
            /** splitHasBeenDeployed (bool) */
            splitHasBeenDeployed: output[1],
        };
    },
};
exports.getSellerOrOwnerOf = {
    parseOutput: (output) => {
        return {
            /** ownerOrSeller (address payable) */
            ownerOrSeller: output[0],
        };
    },
};
exports.getSellerOrOwnersFromCollection = {
    parseOutput: (output) => {
        return {
            /** ownerOrSellers (address payable[]) */
            ownerOrSellers: output[0],
        };
    },
};
exports.getSellerOrOwnersOf = {
    parseOutput: (output) => {
        return {
            /** ownerOrSellers (address payable[]) */
            ownerOrSellers: output[0],
        };
    },
};
exports.getSplitShareLength = {
    parseOutput: (output) => {
        return {
            /** count (uint256) */
            count: output[0],
        };
    },
};
exports.getTokenCreator = {
    parseOutput: (output) => {
        return {
            /** creatorAddress (address) */
            creatorAddress: output[0],
        };
    },
};
//# sourceMappingURL=FNDMiddlewareHelpers.generated.js.map